import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditProjectAllocatedBudgetRequest(
  state: State,
  { project }: Boundaries["editProjectAllocatedBudget"]["request"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToPending() }];
}

function handleEditProjectAllocatedBudgetSuccess(
  state: State,
  { project }: Boundaries["editProjectAllocatedBudget"]["success"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToSuccess() }];
}

function handleEditProjectAllocatedBudgetFailure(
  state: State,
  { project }: Boundaries["editProjectAllocatedBudget"]["request"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectAllocatedBudgetRequested]:
      handleEditProjectAllocatedBudgetRequest,
    [events.editProjectAllocatedBudgetSucceeded]:
      handleEditProjectAllocatedBudgetSuccess,
    [events.editProjectAllocatedBudgetFailed]:
      handleEditProjectAllocatedBudgetFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
